import {defineStore} from 'pinia'
import {useCurrentAppPlatform} from '@toolify/client/src/modules/platform/composables/useCurrentAppPlatform'
import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {App} from '@capacitor/app'
import {useRouter} from 'vue-router'
import {useAppStore} from '../AppStore/useAppStore'
import {useMobileNotificationsStore} from '../MobileNotificationsStore/useMobileNotificationsStore'
import {ref} from 'vue'
import {getAppPathFromUrl} from '@toolify/client/src/modules/routes/functions/getAppPathFromUrl'

export const useMobileAppStore = defineStore('mobileApp', () => {
  const {currentAppPlatformType} = useCurrentAppPlatform()
  const router = useRouter()
  const appStore = useAppStore()
  const mobileNotificationsStore = useMobileNotificationsStore()
  const hasLaunchUrlBeenDetermined = ref(false)

  async function initialize(): Promise<void> {
    if(currentAppPlatformType === AppPlatformType.Mobile) {
      App.addListener('appUrlOpen', onAppUrlOpen)
    }
  }

  function dispose(): void {
    if(currentAppPlatformType === AppPlatformType.Mobile) {
      App.removeAllListeners()
    }
  }

  function convertAppLaunchUrlToPath(url: string): string {
    return getAppPathFromUrl(new URL(url), url)
  }

  function onAppUrlOpen(event: { url: string }): void {
    try {
      const path = convertAppLaunchUrlToPath(event.url)
      if (hasLaunchUrlBeenDetermined.value) {
        router.push(path)
      }
    } catch (error) {
      alert(`Failed to handle deep link: ${error instanceof Error ? error.message : JSON.stringify(error)}`)
    }
  }

  return {
    initialize,
    dispose,
    convertAppLaunchUrlToPath,
    hasLaunchUrlBeenDetermined,
  }
})
